<template>
  <b-dropdown variant="link" no-caret class="notifications-menu">
    <template slot="button-content">
      <i ref="notificationsIcon" class="icon-alarm" />
      <span v-show="notifications.length" :class="level" class="notifications-badge">{{ notifications.length }}</span>
    </template>

    <dropdown-custom-item class="notifications-body">
      <template slot="customItem">
        <ul v-if="notifications.length>0" class="list-group">
          <li v-for="(notif, i) in filteredNotifications" :key="i" :class="'text-' + notif.type" class="list-group-item">
            <div class="d-flex justify-content-between align-items-center">
              <span :title="notif.message">{{ notif.message || $t('notifications:undefinedMessage') | capitalize }}</span>
              <small class="text-muted">{{ notif.date | date('hour') }}</small>
            </div>
          </li>
        </ul>

        <ul v-else class="list-group">
          <li class="list-group-item text-center text-muted font-italic">{{ $t('notifications:noData') | capitalize }}</li>
        </ul>
      </template>
    </dropdown-custom-item>

    <dropdown-custom-item v-if="notifications.length>0" class="notifications-footer text-right">
      <template slot="customItem">
        <router-link id="goToNotificationsLink" class="btn btn-flat w-100 border-top" to="/notifications" @click.native="close">{{ $t('notifications:seeAll') | capitalize }}</router-link>
      </template>
    </dropdown-custom-item>
  </b-dropdown>
</template>

<script>
import { orderBy, take, findIndex } from 'lodash-es'
import { mapGetters } from 'vuex'

import BDropdown from 'bootstrap-vue/es/components/dropdown/dropdown'

export default {
  components: { BDropdown },

  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(['notifications']),

    // Show only last 5 notification at first, but all if expanded
    filteredNotifications () {
      const ordered = orderBy(this.notifications, 'date', 'desc')
      return take(ordered, 5)
    },

    // Return higher level of notifications
    level () {
      let level = 'info'
      if (findIndex(this.notifications, function (n) { return n.type === 'info' }) !== -1) level = 'info'
      if (findIndex(this.notifications, function (n) { return n.type === 'success' }) !== -1) level = 'success'
      if (findIndex(this.notifications, function (n) { return n.type === 'warning' }) !== -1) level = 'warning'
      if (findIndex(this.notifications, function (n) { return n.type === 'error' }) !== -1) level = 'error'
      return level
    }
  },

  methods: {
    close () {
      this.$refs.notificationsIcon.click()
    }
  }
}
</script>

<style lang="scss">
  @import "~@/scss/variables";

  .notifications-menu {
    .notifications-body {
      width: auto;
      min-width: 300px;
      max-width: 600px;
      min-height: 40px;
      padding: 0;
      background-color: $white;

      ul {
        max-height: 60vh;
        padding-top: 5px;
        margin: 0;
        overflow-y: auto;

        li {
          padding: 5px 10px;
          border: none;

          & > div {
            & > span {
              margin-right: 10px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            & > small {
              padding-right: 3px;
              white-space: nowrap;
            }
          }

          &.text-error {
            color: $danger;
          }
        }
      }
    }

    .notifications-footer {
      padding: 0;

      .btn {
        padding: 0.4rem 0.8rem;
        font-size: 0.7rem;
        text-transform: none;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
  </style>
